// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";

function calcPercent(numerator, denominator) {
  return Math.ceil(numerator / denominator * 100.00) | 0;
}

function makeMatrixKey(studentId, categoryId) {
  return studentId + "/" + categoryId;
}

var Ctx = {
  name: "AcademyParallaxTypes"
};

var include = ContextMaker$LiteracyplanetClientFlags.Make(Ctx);

var initialContext = include.initialContext;

var context = include.context;

var P = include.P;

var Provider = include.Provider;

var ContextMakerProviderNotFound = include.ContextMakerProviderNotFound;

var use = include.use;

export {
  calcPercent ,
  makeMatrixKey ,
  Ctx ,
  initialContext ,
  context ,
  P ,
  Provider ,
  ContextMakerProviderNotFound ,
  use ,
}
/* include Not a pure module */
